/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */
import {Reducer} from 'redux';

import {IMember} from 'interfaces';
import {
  ROOM_MEMBERS_FETCHING,
  ROOM_MEMBERS_FETCHING_DONE,
  ROOM_MEMBERS_FETCHING_ERROR,
  RoomsActions
} from 'store/action/rooms';
import {IPortalError} from 'utility/error-handler';

export interface IRoomMembersState {
  roomMembers: IMember[] | null;
  isFetching: boolean;
  error: null | IPortalError;
}

const initialRoomMembersState = {
  roomMembers: null,
  isFetching: false,
  error: null
};
const roomMembersReducer: Reducer<Readonly<IRoomMembersState>, RoomsActions> = (
  state: IRoomMembersState = initialRoomMembersState,
  action: RoomsActions
) => {
  switch (action.type) {
    case ROOM_MEMBERS_FETCHING:
      return {
        ...state,
        error: null
      };
    case ROOM_MEMBERS_FETCHING_ERROR:
      return {
        ...state,
        error: action.error,
        isFetching: false
      };
    case ROOM_MEMBERS_FETCHING_DONE:
      return {
        ...state,
        roomMembers: action.payload,
        error: null,
        isFetching: false
      };
    default:
      return state;
  }
};

export default roomMembersReducer;